<template>
  <FormHeading :h="5">
    Для выставления счёта заполните следующие поля:
  </FormHeading>
  <v-form :ref="setFormRef">
    <AppRow sequence-two>
      <TextField v-model="company.name" :rules="[required]" label="Название компании" />
      <TextField v-model="company.inn" :rules="[required]" label="ИНН" />
      <TextField v-model="company.kpp" :rules="[required]" label="КПП" />
      <TextField v-model="company.address" :rules="[required]" label="Юридический адрес" />
    </AppRow>
    <AppBtn primary :disabled="!valid" :loading @click="proceed">
      Получить счёт {{ price }}
    </AppBtn>
  </v-form>
</template>

<script setup lang="ts">
import { sendBillRequest } from '~/helpers/http';
import { calcTotalPrice } from '~/helpers/price';
import type { BillRequest, VisaForm } from '~/types';

const props = defineProps<{
  form: VisaForm;
}>();

const { displayPrice } = useFormat();
const { required } = useValidation();
const { currency } = useBranch();
const { buildSuccessRoute } = useRouting();
const { setFormRef, loading, submit, valid } = useForm();

const total = computed(() => calcTotalPrice(props.form, currency));
const price = displayPrice(total.value);

const company = reactive<BillRequest['company']>({
  name: '',
  inn: '',
  kpp: '',
  address: ''
});

function proceed() {
  submit(async () => {
    const { form } = props;
    const success = sendBillRequest({ formId: form.id, company });
    if (!success) return;
    const successPath = buildSuccessRoute(form.id, form.product.country, 'bill');
    useRouter().push(successPath);
  });
}
</script>